module.exports = __webpack_public_path__ + "img/icon-inprogress.f704b852.svg";